import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import { api } from './api.reducer';
import { alert } from './alert.reducer';

export const rootReducer = combineReducers({
  routing: routerReducer,
  api,
  alert,
  form: formReducer,
});
